import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { RESTAURANT } from "../data";
import OliveBranch from "../components/OliveBranch";

const LegalShell = ({ title, children }) => {
  const navigate = useNavigate();
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="bg-qs-bg min-h-screen pt-32 pb-24 px-5 md:px-10">
      <div className="max-w-3xl mx-auto">
        <button
          data-testid="legal-back"
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 text-qs-text2 hover:text-qs-red transition-colors mb-8 font-outfit text-sm"
        >
          <ArrowLeft size={16} /> Zurück
        </button>
        <h1 className="font-cormorant text-4xl sm:text-5xl text-qs-text">{title}</h1>
        <OliveBranch className="w-24 text-qs-gold my-6" />
        <div className="font-outfit text-qs-text2 leading-relaxed space-y-6 text-[15px]">
          {children}
        </div>
      </div>
    </div>
  );
};

const Block = ({ heading, children }) => (
  <div>
    <h2 className="font-cormorant text-2xl text-qs-text mb-2">{heading}</h2>
    {children}
  </div>
);

export function ImpressumPage() {
  return (
    <LegalShell title="Impressum">
      <Block heading="Angaben gemäß § 5 TMG">
        <p>
          {RESTAURANT.name}<br />
          {RESTAURANT.street}<br />
          {RESTAURANT.city}
        </p>
      </Block>
      <Block heading="Kontakt">
        <p>
          Telefon: {RESTAURANT.phone}<br />
          E-Mail: {RESTAURANT.email}
        </p>
      </Block>
      <Block heading="Umsatzsteuer-ID">
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: auf Anfrage.</p>
      </Block>
      <Block heading="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
        <p>
          {RESTAURANT.name}<br />
          {RESTAURANT.street}, {RESTAURANT.city}
        </p>
      </Block>
      <Block heading="Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          {" "}
          <a className="text-qs-red underline" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </a>.
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Block>
      <Block heading="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
        </p>
      </Block>
    </LegalShell>
  );
}

export function DatenschutzPage() {
  return (
    <LegalShell title="Datenschutzerklärung">
      <Block heading="1. Datenschutz auf einen Blick">
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
          personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten
          sind alle Daten, mit denen Sie persönlich identifiziert werden können.
        </p>
      </Block>
      <Block heading="2. Verantwortliche Stelle">
        <p>
          {RESTAURANT.name}<br />
          {RESTAURANT.street}, {RESTAURANT.city}<br />
          Telefon: {RESTAURANT.phone}<br />
          E-Mail: {RESTAURANT.email}
        </p>
      </Block>
      <Block heading="3. Reservierungsformular">
        <p>
          Wenn Sie uns über das Reservierungsformular Anfragen zukommen lassen, werden Ihre Angaben
          aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
          der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs.
          1 lit. b DSGVO.
        </p>
      </Block>
      <Block heading="4. Ihre Rechte">
        <p>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger sowie den Zweck der Datenverarbeitung
          und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.
        </p>
      </Block>
      <Block heading="5. Server-Log-Dateien">
        <p>
          Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten
          Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Diese Daten dienen der
          technischen Bereitstellung und Sicherheit der Website.
        </p>
      </Block>
      <Block heading="6. Externe Dienste">
        <p>
          Diese Website nutzt Google Maps zur Darstellung unseres Standorts. Anbieter ist die Google
          Ireland Limited. Bei Nutzung von Google Maps können Daten an Google übertragen werden.
        </p>
      </Block>
    </LegalShell>
  );
}

export default ImpressumPage;
